export default class ErpProductCategoryEntity {
    static getEntityData(elem: any) {
        return {
            id: elem.querySelector("#erp_product_category_id") ? (elem.querySelector("#erp_product_category_id") as HTMLInputElement).value : null,
            uuid: elem.querySelector("#erp_product_category_id") ? (elem.querySelector("#erp_product_category_id") as HTMLInputElement).value : null,
            name: (elem.querySelector("#erp_product_category_name") as HTMLInputElement).value
        }
    }
}